<div class="pnc-full-lot-number-chip"
  [ngClass]="chipColorClass"
  [attr.data-cy]="chipDataCy('pnc-full-lot-number-chip')">
  <app-tooltip [dynamic]="data.isValid" [message]="chipTooltip" [placement]="'bottom'" style="width: 100%">
    <span [attr.data-cy]="chipDataCy('pnc-full-lot-number-chip-label')">{{data.fullLotNumber}}</span>
  </app-tooltip>
  <div (click)="onChipDelete()"
    class="iwp-icon-gen_close_l pnc-full-lot-number-chip-delete-button"
  [attr.data-cy]="chipDataCy('pnc-full-lot-number-chip-delete-button')"></div>
</div>

<ng-template #chipTooltip>
  <div class="pnc-full-lot-number-chip-tooltip" [ngStyle]="{'margin-bottom': showFullLotNumberOnInvalidChip() ? '4px' : 0}">
    <span class="iwp-icon-gen_warning invalid" style="margin-right: 4px"></span>
    <span>Invalid full LOT No.</span>
  </div>
  @if (showFullLotNumberOnInvalidChip()) {
    <span>{{data.fullLotNumber}}</span>
  }
</ng-template>
